export const PER_PAGE = 20;
export const CLIENT_ID = "RoYRoxQu7FzkoEaT5h9PSGUMJXetJNZdBx8WQCcN";
export const CLIENT_SECRET = "UVneByGUFKzsfsAhw9g50UWmUiu6DJW8Hy7RmYyxxKHoLQ0g5CwFGpjOmihoFyPujdphrKdKz7crzRzWzQbxrjHpj5KzYYBDCLhblMkXhcRU9loyR16aXS1E2Keb6brT";
